import { AbstractControl } from '@angular/forms';

import { parseItems } from './parse-items';

export function quantityValidator(control: AbstractControl) {
  const errorLines = parseItems(control.value)
    .filter(({ quantity }) => !quantity)
    .map(({ code }) => code);
  return errorLines.length
    ? {
        requiredQuantity: errorLines.join(', '),
      }
    : null;
}
